const base64urlDecode = (data: string): Uint8Array => {
  let urlSafeEncoded = data.replace(/-/g, "+").replace(/_/g, "/");
  const padding = 4 - (urlSafeEncoded.length % 4);
  if (padding !== 4) {
    urlSafeEncoded += "=".repeat(padding);
  }
  const decodedData = atob(urlSafeEncoded);
  const bytes = new Uint8Array(decodedData.length);
  for (let i = 0; i < decodedData.length; i++) {
    bytes[i] = decodedData.charCodeAt(i);
  }
  return bytes;
};

export const decryptData = async (encryptedDataBase64: string) => {
  const decodedData = base64urlDecode(encryptedDataBase64);
  const key = new TextEncoder().encode("gB2aUWE674ufiheY");
  const iv = new TextEncoder().encode("dkp4fFEUonkSMtd2");

  const cryptoKey = await crypto.subtle.importKey("raw", key.buffer, { name: "AES-CBC" }, false, ["decrypt"]);

  try {
    const decryptedBuffer = await crypto.subtle.decrypt({ name: "AES-CBC", iv: iv.buffer }, cryptoKey, decodedData);
    const decryptedText = new TextDecoder().decode(decryptedBuffer);
    return decryptedText;
  } catch (error) {
    console.error("Decryption failed:", error);
    throw Error("Decryption failed");
  }
};
